export default __webpack_public_path__ + "static/media/YAS0340.34I-29792_-17236_0.0b0335d6.jpg";